webpackJsonp([10],{

/***/ "2x6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FivePics_vue__ = __webpack_require__("qi2W");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba36a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FivePics_vue__ = __webpack_require__("GBwL");
function injectStyle (ssrContext) {
  __webpack_require__("MYU+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ba36a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FivePics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba36a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FivePics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FPVC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.five-pics-wrap[data-v-2ba36a7a] {\n  overflow: hidden;\n  padding: 0.266667rem 0;\n}\n.five-pics-wrap .five-pics-title[data-v-2ba36a7a] {\n  margin: 0.053333rem 0 0.293333rem 0.293333rem;\n  font-size: 17px;\n  font-weight: bold;\n  color: #222222;\n}\n.five-pics-wrap .five-pics-list[data-v-2ba36a7a] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.five-pics-wrap .five-pics-list .pics-item[data-v-2ba36a7a] {\n  width: 8.72rem;\n  height: 5.6rem;\n  margin-right: 0.186667rem;\n  overflow: hidden;\n  position: relative;\n}\n.five-pics-wrap .five-pics-list .pics-item.active img[data-v-2ba36a7a] {\n  -webkit-transform: scale(1, 1);\n          transform: scale(1, 1);\n  margin: 0;\n}\n.five-pics-wrap .five-pics-list .pics-item.active .pics-title[data-v-2ba36a7a] {\n  bottom: 0;\n}\n.five-pics-wrap .five-pics-list .pics-item img[data-v-2ba36a7a] {\n  -webkit-transform: scale(1, 0.9);\n          transform: scale(1, 0.9);\n  border-radius: 0.106667rem;\n  max-height: 100%;\n  -webkit-transition: -webkit-transform ease-in-out 0.2s;\n  transition: -webkit-transform ease-in-out 0.2s;\n  transition: transform ease-in-out 0.2s;\n  transition: transform ease-in-out 0.2s, -webkit-transform ease-in-out 0.2s;\n}\n.five-pics-wrap .five-pics-list .pics-item .pics-title[data-v-2ba36a7a] {\n  position: absolute;\n  bottom: 0.266667rem;\n  width: 100%;\n  max-height: 1.973333rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0.4rem 0.48rem;\n  border-radius: 0.106667rem;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.7)));\n  background: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);\n}\n.five-pics-wrap .five-pics-list .pics-item .pics-title .title[data-v-2ba36a7a] {\n  font-size: 0.48rem;\n  line-height: 0.586667rem;\n  overflow: hidden;\n  color: #ffffff;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  word-break: break-all;\n  -webkit-box-orient: vertical;\n}", ""]);

// exports


/***/ }),

/***/ "GBwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_data)?_c('div',{ref:"picsWrapper",staticClass:"five-pics-wrap",attrs:{"id":_vm.target,"data-spm":_vm.spm}},[(_vm.tag)?_c('h1',{staticClass:"five-pics-title"},[_vm._v(_vm._s(_vm.tag))]):_vm._e(),_vm._v(" "),_c('div',{ref:"picsList",staticClass:"five-pics-list",style:(("transform: translate3D(" + _vm.initPosition + "px, 0, 0)"))},_vm._l((_vm.modifyData),function(pic,index){return _c('div',{key:index,staticClass:"pics-item"},[_c('a',{attrs:{"href":pic.link ? pic.link : 'javascript:;',"onclick":"return false;"}},[_c('img',{attrs:{"src":pic.imageUrl,"alt":""}}),_vm._v(" "),_c('footer',{staticClass:"pics-title"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(pic.title))])])])])}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MYU+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FPVC");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0bd8b0e9", content, true, {});

/***/ }),

/***/ "UTZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");


var nativeUtil = {
    openContent: function openContent(url, data) {
        if (!url) {
            return;
        }
        if (/MSOHU/i.test(window.navigator.userAgent) && window.Panther) {
            var urlObj = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].parseURL(url);
            var spmCode = urlObj.spm || '';
            var scmCode = urlObj.scm || '';
            var regMatch = /\/(a|picture)\/(\d+)(_\d+\?|\?)/.test(url);
            var authorId = data.authorId || data.authId;
            if (RegExp.$1 === 'a') {
                // 匹配文章页
                if (typeof Panther.openNewsContent === 'function') {
                    Panther.openNewsContent(RegExp.$2, spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else if (RegExp.$1 === 'picture') {
                // 匹配图集页
                if (typeof Panther.openImageSet === 'function') {
                    Panther.openImageSet(Number(RegExp.$2), spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else {
                window.location.href = url;
            }
        } else {
            window.location.href = url;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (nativeUtil);

/***/ }),

/***/ "qi2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__ = __webpack_require__("YrTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__ = __webpack_require__("ZpuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_native_util_js__ = __webpack_require__("UTZg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @desc: 五图组件
 * 基本思想：复制开头两个元素到末尾，复制末尾两个元素到开头，形成前后共四个虚假的视觉模拟元素
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FivePics',
    props: {
        target: {
            default: '',
            type: String
        },
        data: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 是否开启自动轮播
        loop: {
            type: Boolean,
            default: true
        },
        // 容器动画间隔
        speed: {
            type: Number,
            default: 3000
        },
        // 容器动画持续时间
        duration: {
            type: Number,
            default: 200
        },
        // 起始序号
        start: {
            type: Number,
            default: 0
        },
        // 滑动距离阀值
        slideWidth: {
            type: Number,
            default: 30
        },
        // spm码
        spm: {
            default: '',
            type: String
        },
        tag: {
            default: '',
            type: String
        }
    },
    data: function data() {
        // 缩放比例
        var scale = parseFloat(document.documentElement.style.fontSize) / 37.5;
        // 单元宽度 = 一个大图宽度 + 单边间距
        var unitWidth = 334 * scale;
        // 判断初始位置是否有误, 若超过数据范围。就设置为0
        var initStart = this.start < this.data.length ? this.start : 0;
        // 初始位置 = 单元宽度 + 一个大图宽度 - 单边侧图漏出宽度
        var initPosition = (-644 - unitWidth * initStart) * scale;
        // 滑动距离阀值
        var slideLimit = this.slideWidth * scale;
        return {
            // 初始设置为与初始位置一致
            currentPosition: initPosition * scale,
            // 最大位置，在modifyData中计算
            maxIndex: 0,
            // 初始序号
            index: initStart + 2,
            // touch事件兼容
            touchEvent: __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getTouchEvent(),
            initPosition: initPosition,
            scale: scale,
            timer: null,
            unitWidth: unitWidth,
            initStart: initStart,
            slideLimit: slideLimit
        };
    },

    methods: {
        // 初始化active状态
        initActive: function initActive() {
            var items = this.list.querySelectorAll('.pics-item');
            __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[this.index], 'active');
            this.handleShock(this.index);
        },

        // 开启自动滚动
        autoLoop: function autoLoop() {
            if (this.timer) {
                clearInterval(this.timer);
            } else {
                this.setTimer();
            }
        },

        // 自动滚动的计时器
        setTimer: function setTimer() {
            var _this = this;

            if (this.loop) {
                this.timer = setInterval(function () {
                    _this.setTransitionDuration(_this.duration);
                    _this.slideNext();
                }, this.speed);
            }
        },

        // 添加touch监听，transition监听
        addTouchListener: function addTouchListener() {
            var wrapper = this.$refs.picsWrapper;
            // 监听touch
            __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].addHandler(wrapper, this.touchEvent._EVT_DOWN, this.onTouchStart);
            // 监听transitionend
            __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].addHandler(this.list, this.touchEvent._EVT_TRANSITIONEND, this.transitionEnd);
        },

        // touch事件
        onTouchStart: function onTouchStart(e) {
            var _this2 = this;

            var wrapper = this.$refs.picsWrapper;
            var startX = __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getEventPos().x;
            var startY = __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getEventPos().y;
            var startTime = new Date().getTime();
            var moveLength = 0;
            var moveLengthY = 0;
            var transformLength = 0;
            var onTouchMove = function onTouchMove(e) {
                // 移动距离
                moveLength = __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getEventPos().x - startX;
                moveLengthY = __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getEventPos().y - startY;
                // 如果是水平方向的移动就禁止默认操作
                if (Math.abs(moveLength) > Math.abs(moveLengthY)) {
                    __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].preventDefault(e);
                    __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].stopPropagation(e);
                }
                // 组件transform位置
                transformLength = _this2.currentPosition + moveLength;
                // 初始位置+移动距离就等于组件的滑动距离
                _this2.setTransformX(transformLength);
            };
            var onTouchEnd = function onTouchEnd() {
                var endTime = new Date().getTime();
                _this2.setTransitionDuration(_this2.duration);
                if (moveLength > _this2.slideWidth) {
                    _this2.slidePrev();
                } else if (moveLength < -_this2.slideWidth) {
                    _this2.slideNext();
                } else {
                    _this2.setTranformIndex(_this2.index);
                }
                // 重新轮播
                _this2.setTimer();
                // 移除end事件
                __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].removeHandler(wrapper, _this2.touchEvent._EVT_MOVE, onTouchMove);
                __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].removeHandler(wrapper, _this2.touchEvent._EVT_UP, onTouchEnd);
                // fake click时间间隔小于100且移动距离少于30时，视为点击
                if (endTime - startTime < 100 && Math.abs(moveLength) < 30) {
                    var url = __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getTarget(e).parentNode && __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getTarget(e).parentNode.getAttribute('href') || '/';
                    __WEBPACK_IMPORTED_MODULE_2__utils_native_util_js__["a" /* default */].openContent(url);
                }
            };
            // 停止轮播
            clearInterval(this.timer);
            __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].addHandler(wrapper, this.touchEvent._EVT_MOVE, onTouchMove);
            __WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].addHandler(wrapper, this.touchEvent._EVT_UP, onTouchEnd);
        },

        // 后滑
        slideNext: function slideNext() {
            this.index = this.index + 1;
        },

        // 前滑
        slidePrev: function slidePrev() {
            this.index = this.index - 1;
        },

        // 首位loop的伪造循环效果
        fakeLoop: function fakeLoop() {
            if (this.index > this.maxIndex - 2) {
                this.index = 2;
            }
            if (this.index < 2) {
                this.index = this.maxIndex - 2;
            }
        },

        // 通过位置直接设置容器的便偏移
        setTransformX: function setTransformX(position) {
            this.list.style.transform = 'translate3D(' + position + 'px, 0, 0)';
        },

        // 通过序号设置容器的偏移
        setTranformIndex: function setTranformIndex(newIndex) {
            // 设置active状态
            var items = this.list.querySelectorAll('.pics-item');
            for (var i in items) {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].hasClass(items[i], 'active')) {
                    __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].removeClass(items[i], 'active');
                }
            }
            __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[newIndex], 'active');
            // 为防止视觉抖动对头尾相同的复制元素处理active
            this.handleShock(newIndex);
            // wrapper转移位置
            this.currentPosition = this.initPosition - this.unitWidth * (newIndex - this.initStart - 2);
            this.list.style.transform = 'translate3D(' + this.currentPosition + 'px, 0, 0)';
        },

        // 防止视觉抖动处理
        handleShock: function handleShock(newIndex) {
            var items = this.list.querySelectorAll('.pics-item');
            switch (newIndex) {
                case (newIndex, this.maxIndex - 1):
                    __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[2], 'active');
                    break;
                case this.maxIndex - 2:
                    __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[1], 'active');
                    break;
                case 2:
                    __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[this.maxIndex - 1], 'active');
                    break;
                case 1:
                    __WEBPACK_IMPORTED_MODULE_1__utils_helper_js__["a" /* default */].addClass(items[this.maxIndex - 2], 'active');
                    break;
                default:
                    break;
            }
        },

        // 设置容器的动画时间，0ms即取消
        setTransitionDuration: function setTransitionDuration(duration) {
            if (duration) {
                this.list.style.transitionDuration = duration + 'ms';
            } else {
                this.list.style.transitionDuration = '0ms';
            }
        },

        // 容器transitionEnd事件
        transitionEnd: function transitionEnd(e) {
            // 只有list的transitionend才会进行接下来的判断
            if (__WEBPACK_IMPORTED_MODULE_0__utils_eventHelper_js__["a" /* default */].getTarget(e).className.indexOf('five-pics-list') > -1) {
                // 为防止逆滚动效果，取消transition
                this.setTransitionDuration();
                this.fakeLoop();
            }
        }
    },
    computed: {
        // 判断是否有数据，从而是否渲染
        has_data: function has_data() {
            return this.data.length > 0;
        },

        // 改造数据，复制首尾四项
        modifyData: function modifyData() {
            var data = this.data.slice();
            var len = data.length;
            var first = data.slice(0, 2);
            var last = data.slice(-2);
            this.maxIndex = last.concat(data).concat(first).length - 1;
            return last.concat(data).concat(first);
        }
    },
    watch: {
        index: function index(newIndex) {
            this.setTranformIndex(newIndex);
        }
    },
    mounted: function mounted() {
        this.list = this.$refs.picsList;
        if (this.list) {
            this.initActive();
            this.addTouchListener();
            this.autoLoop();
        }
    }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.a20ca5bba56977a2d1b9.js